module.exports = __webpack_public_path__ + "img/3.aff35038.png";